import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';

const Kontakt = ({ t }) => (
  <PagesLayout className="contact">
    <h2>{t('Kontakt')}</h2>
    <h3>{t('Adresa')}</h3>
    <ul>
      <li>{t('Peer2Peer, s.r.o.')}</li>
      <li>{t('Mostová 2')}</li>
      <li>{t('811 02 Bratislava')}</li>
    </ul>
    <h3>{t('E-mail')}</h3>
    <a href={`mailto:${t('info@majak.sk')}`}>{t('info@majak.sk')}</a>
    <h3>{t('Telefónne číslo')}</h3>
    <a href={`tel:${t('+421 948 97 17 17')}`}>{t('+421 948 97 17 17')}</a>
  </PagesLayout>
);

Kontakt.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(Kontakt);



// WEBPACK FOOTER //
// ./src/features/pages/Kontakt.js